function toBlobUri(bytes, mimeType) {
    if (typeof URL !== 'undefined' &&
        typeof Blob !== 'undefined' &&
        typeof URL.createObjectURL === 'function') {
        return URL.createObjectURL(new Blob([bytes], { type: mimeType }));
    }
    return `memory://${crypto.randomUUID()}`;
}
/**
 * Download one manifest item, SHA-256 verify, store locally.
 * Never throws — download/hash failures return `{ ok: false }` so the playlist
 * cache can keep playable siblings (images) instead of blanking the TV.
 */
export async function ensureAssetCached(input) {
    const existing = await input.store.get(input.item.assetId);
    if (existing && existing.sha256 === input.item.sha256) {
        return { ok: true };
    }
    let bytes;
    try {
        bytes = await input.api.downloadBytes(input.item.url);
    }
    catch {
        return { ok: false, reason: 'download_failed' };
    }
    const digest = await input.hasher.sha256Hex(bytes);
    if (digest !== input.item.sha256) {
        return { ok: false, reason: 'hash_mismatch' };
    }
    await input.store.put({
        assetId: input.item.assetId,
        sha256: input.item.sha256,
        mimeType: input.item.mimeType,
        localUri: toBlobUri(bytes, input.item.mimeType),
        bytes,
    });
    return { ok: true };
}
//# sourceMappingURL=ensure-asset.js.map